import { Link } from 'react-router-dom'
import { routes } from 'src/navigation/routes'
import { BigLink, SubLink } from './components'

export const TeacherMenu = () => (
  <div className="sidebarHb-wrap">
    <div className="sidebarHb-top">
      <div className="sidebarHb-logo">
        <Link to={routes.root}>
          <img src="/account/img/logo.svg" alt="" />
        </Link>
      </div>
      {/* <i className="hb-ico arrow-left"></i> */}
    </div>
    <div className="sidebarHb-block">
      <div className="sidebarHb-drop">
        <BigLink to={routes.root} exact>
          <i className="hb-ico sidebarHb-ico-1" />
          Home
        </BigLink>
      </div>
    </div>
    <div className="sidebarHb-block">
      <div className="sidebarHb-drop">
        <BigLink to={routes.students.index}>
          <i className="hb-ico sidebarHb-ico-2" />
          Students
        </BigLink>
      </div>
    </div>
    <div className="sidebarHb-block">
      <div className="sidebarHb-drop">
        <BigLink to={routes.classrooms.index}>
          <i className="hb-ico sidebarHb-ico-3" />
          Classrooms
        </BigLink>
      </div>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.practices.index}>
        <i className="hb-ico sidebarHb-ico-4" />
        Assignments
        {/* <i className="hb-ico drop-arrow"></i> */}
      </BigLink>
      <ul className="sidebarHb-list">
        <li>
          <SubLink exact to={routes.practices.index}>
            Practices
          </SubLink>
        </li>
        <li>
          <SubLink to={routes.tests.index}>Tests</SubLink>
        </li>
        <li>
          <SubLink to={routes.video.index}>Video lessons</SubLink>
        </li>
      </ul>
    </div>
    <div className="sidebarHb-block">
      <div className="sidebarHb-drop">
        <BigLink to={routes.timetable.index}>
          <i className="hb-ico sidebarHb-ico-5" />
          Timetable
        </BigLink>
      </div>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.downloads.index}>
        <i className="hb-ico sidebarHb-ico-6" />
        Downloads
      </BigLink>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.printables.index}>
        <i className="hb-ico sidebarHb-ico-7" />
        My Shop
      </BigLink>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.public_lessons.index}>
        <i className="hb-ico sidebarHb-ico-8" />
        Public lessons
      </BigLink>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.draw}>
        <i className="hb-ico sidebarHb-ico-8" />
        Whiteboard
      </BigLink>
    </div>
  </div>
)
